import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ScreenUtilsService } from 'core/services';
import { BehaviorSubject } from 'rxjs';
import { DsgTranslatePipe } from '../../pipes/translate.pipe';

export type LCrudMode = 'save' | 'update'

@Component({
  selector: 'ss-crud-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    DsgTranslatePipe
  ],
  host: {
    class: 'responsive-actions flex--justify-between padding-standard'
  },
  templateUrl: './crud-toolbar.component.html',
  styleUrls: ['./crud-toolbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrudToolbarComponent {

  @Output('modeChange')
  readonly modeSubject = new BehaviorSubject<LCrudMode>(null)
  @Input() get mode() {
    return this.modeSubject.value
  }
  set mode(value) {
    this.modeSubject.next(value)
  }

  @Output()
  readonly save = new EventEmitter()

  @Output()
  readonly delete = new EventEmitter()

  @Output()
  readonly reset = new EventEmitter()


  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs

  constructor(
    private readonly _screenUtilsService: ScreenUtilsService
  ) {

  }




}
